module.exports = __webpack_public_path__ + "static/media/viewer.a4247a02.png";